<p class="alert alert-success" *ngIf="registerSuccessMessage"> Event Registration Successfully!</p>
<p class="alert alert-success" *ngIf="registerCancelMessage"> Cancelled Event Registration Successfully!</p>
<p class="alert alert-success" *ngIf="userWaitingList"> You will be on Waiting list!</p>

<div class="alert alert-success" *ngIf="alertSuccess">
  Event deleted successfully!
</div>

<div class="alert alert-success" *ngIf="alertSuccessRejected">
  Event rejected successfully!
</div>
<div class="alert alert-success" *ngIf="alertSuccessCompleted">
  Event completed successfully!
</div>
<div class="alert alert-danger" *ngIf="alertSuccessAttended">
  Workday Id should be of 6 digits!
</div>
<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="alert alert-success" *ngIf="alertReminderSentSuccess">
  Reminder sent successfully!
</div>
<div class="alert alert-success" *ngIf="alertNotificationSentSuccess">
  Email notification sent successfully!
</div>


<p class="alert alert-success" *ngIf="successMsg"> {{userAttendanceMsg}} </p>
<p class="alert alert-danger" *ngIf="errorMsg"> {{userAttendanceMsg}} </p>

<div
  *ngIf="(adminId==1||adminId==2||adminId==3 || isNaacAdminForEvent || isbpgAdmin || isbpgLeadAdmin) && iconButtonVisible =='T'">
  
  <div class="col-md-12 col-xs-12 col-sm-12 ml-5 heading" style="display: inline-flex;">
    <span class="span-create-edit-hoshin color">Event Attendance</span>
    <span class="pt-2" style="font-size: 13px;"><a href="assets/userguides/EventAttendanceUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
  </div>
  <div class="event-attendence">
    <div class="col-md-8 attendence-section">
      <span class="col-md-5">Event Attendance Integration</span>
      <div class="div-style">
        <input type="text" class="form-control deviceid-input" id="eventAttendanceId" maxlength="6"
          placeholder="Scan/enter badge id" (keyup)="addEventAttendance(selectedEventsDetails.eventId,'badge',$event)">
      </div>
      <div class="label">
        <span class="col-md-5 or-align">Or</span>
      </div>
      <div>
        <input type="text" class="form-control deviceid-input" id="eventAttendanceId" maxlength="6"
          placeholder="Enter workday id" (keyup)="addEventAttendance(selectedEventsDetails.eventId,'workday',$event)"
          (keyup.enter)="enterPress($event)">
      </div>
    </div>
  </div>
  
</div>

<div class="common-padding" *ngIf="selectedEventsDetails != null">
  <div class="col-md-7">
    <div class="heading">
      <h4>{{selectedEventsDetails.eventName}}</h4>
    </div>

    <div class="timezon">
      <span>{{selectedEventsDetails.eventCreateDate | date: 'MM-dd-yyyy'}}</span><span class="pipe">|</span><span
        class="txt-transform">{{selectedEventsDetails.startTime}}</span> to <span
        class="txt-transform">{{selectedEventsDetails.endTime}}</span><span> {{selectedEventsDetails.timeZone}}
      </span><span class="common-line-height"><span class="pipe">|</span>{{selectedEventsDetails.venue}}</span><br>
      <div class="lineheight">
        <p>{{selectedEventsDetails.bpgName}}</p>
      </div>
    </div>
    <div class="div-top-space fontFamily">
      <span *ngIf="selectedEventsDetails.eventCoordinatorName">Event Coordinator Name:
        {{selectedEventsDetails.eventCoordinatorName}}</span>
      <span class="pipe" *ngIf="selectedEventsDetails.eventCoordinatorName">|</span>
      <span *ngIf="selectedEventsDetails.eventSpeaker">Speaker Name: {{selectedEventsDetails.eventSpeaker}}</span>
      <span class="pipe" *ngIf="selectedEventsDetails.eventCoordinatorName">|</span>
      <span>Max Attendees: {{selectedEventsDetails.maxAttendeece}}</span>
    </div>
    <div class="fontFamily" *ngIf="this.meetinglink">Meeting Link:
      <a href="{{this.meetinglink}}" target="_blank" rel="noopener">{{selectedEventsDetails.virtualMeetingLinks}}</a>
    </div>
    <div class="div-top-space">
      <p>{{selectedEventsDetails.description}}</p>
    </div>

    <div class="div-top-space fontFamily">
      <div
        *ngIf="(selectedEventsDetails.externalRefLnk1 != null)||(selectedEventsDetails.externalRefLnk2 != null)||(selectedEventsDetails.externalRefLnk3 != null)">
        <span>External link:</span>
      </div>
      <div class="fontFamily" *ngIf="this.link1">
        <a href="{{this.link1}}" target="_blank" rel="noopener">{{selectedEventsDetails.externalRefLnk1}}</a>
      </div>
      <div class="fontFamily" *ngIf="this.link2">
        <a href="{{this.link2}}" target="_blank" rel="noopener">{{selectedEventsDetails.externalRefLnk2}}</a>
      </div>
      <div class="fontFamily" *ngIf="this.link3">
        <a href="{{this.link3}}" target="_blank" rel="noopener">{{selectedEventsDetails.externalRefLnk3}}</a>
      </div>
    </div>


    <div class="form-group div-top-space "
      *ngIf="(adminId==1||isBpgLeadAdmin==true|| isNaacAdminForEvent) && eventStatus=='SUBMITTED'  && eventCreateDate >= today && iconButtonVisible =='V'&& iconButtonVisible !='T' && hideAllButtons == false">
      <textarea class="form-control" id="approverComment" name="approverComment" maxlength="500"
        [(ngModel)]="approverComment" placeholder="Enter comment "></textarea>
    </div>
  </div>
  <div class="colMd col-md-5">
    <div class="alignText signed-style" *ngIf="eventStatus=='SCHEDULED' && iconButtonVisible !='T'">
      <i class="fa fa-user icon-user ie-position" aria-hidden="true"></i>
      <span class="icon-user fontFamily margin-align ">{{this.countOfSignedUser}} Members Signed Up</span>
    </div>
   
    <div class="alignText top-padding" *ngIf="eventStatus=='SCHEDULED' && iconButtonVisible !='T'">
      <button type="button"
        class="btn btn-danger col-sm-2 col-md-2 font-family-button  button-alignment margin-align ie-position"
        (click)="saveEventRegistration('REGISTER')"
        *ngIf="signUnsigned!=true && validDate == false && hideAllButtons == false"
        [disabled]="registerSuccessMessage||registerCancelMessage||userWaitingList">SIGN UP</button>
    </div>
    <div class="alignText top-padding" *ngIf="eventStatus=='SCHEDULED' && iconButtonVisible !='T'">
      <button type="button"
        class="btn btn-danger col-sm-2 col-md-2 font-family-button  button-alignment margin-align ie-position"
        (click)="openAndCloseMatDialog('open')" *ngIf="validDate == false && hideAllButtons == false"
        [disabled]="registerSuccessMessage||registerCancelMessage||userWaitingList">SIGN UP FOR A
        GROUP</button>
    </div>
    <div class="alignText top-padding top-padding"
      *ngIf="eventStatus=='SCHEDULED' && signUnsigned==true && iconButtonVisible !='T' && validDate == false && hideAllButtons == false">
      <button type="button"
        class="btn btn-danger col-sm-2 col-md-2 font-family-button  button-alignment margin-align ie-position"
        (click)="saveEventRegistration('CANCEL')"
        [disabled]="registerSuccessMessage||registerCancelMessage||userWaitingList">SIGN OUT</button>
    </div>

    <div class="alignText top-padding"
      *ngIf="(adminId==1||adminId==2||adminId==3||isbpgAdmin|| isNaacAdminForEvent||isbpgLeadAdmin)&&(eventStatus=='SCHEDULED'&&validDate == false)&& (isChapterAdmins ==true)&& hideAllButtons == false && iconButtonVisible !='T' && fromLink == false">
      <button type="button" id="emailReminderBtnClick"
        class="btn btn-danger col-sm-2 col-md-2 font-family-button  button-alignment margin-align ie-position"
        (click)="sendReminderClick()" [disabled]="registerSuccessMessage||registerCancelMessage||userWaitingList">SEND
        REMINDER</button>
    </div>

    <div class="alignText top-padding"
      *ngIf="(adminId==1||isBpgLeadAdmin==true|| isNaacAdminForEvent) && eventStatus=='SUBMITTED'&& eventCreateDate >= today && iconButtonVisible =='V'&& iconButtonVisible !='T' && hideAllButtons == false && fromLink == false">
      <p class="alert-invalid ie-position" *ngIf="invalidCommentForApprove">*Please enter approver comment</p>
      <button id="approveBtnClick" type="button"
        class="btn btn-danger col-sm-2 col-md-2 font-family-button  button-alignment margin-align ie-position"
        (click)="approveClick()" [disabled]="alertSuccessApproved||alertSuccessRejected">APPROVE</button>
    </div>
    <div class="alignText top-padding"
      *ngIf="(adminId==1||isBpgLeadAdmin==true|| isNaacAdminForEvent) && eventStatus=='SUBMITTED' && eventCreateDate >= today && iconButtonVisible =='V'&& iconButtonVisible !='T' && hideAllButtons == false && fromLink == false">
      <p class="alert-invalid ie-position" *ngIf="invalidCommentForReject">*Please enter rejection comment</p>
      <button id="rejectBtnClick" type="button"
        class="btn btn-danger col-sm-2 col-md-2 font-family-button  button-alignment margin-align ie-position"
        (click)="rejectClick()" [disabled]="alertSuccessApproved||alertSuccessRejected">REJECT</button>
    </div>
    <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>

    <div
      *ngIf="(adminId==1||adminId==2||adminId==3 ||isbpgAdmin|| isNaacAdminForEvent||isbpgLeadAdmin)&&(eventStatus=='NEW'||eventStatus=='REJECTED') && fromLink == false"
      class="alignText top-padding">
      <button type="button"
        class="btn btn-danger col-sm-2 col-md-2 font-family-button button-alignment margin-align ie-position"
        [ngClass]="{'deleted':deleted}" (click)="deleteClick()" data-toggle="modal"
        data-target="#myModal">DELETE</button>
    </div>
    <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>

    <div
      *ngIf="(adminId==1||adminId==2||adminId==3|| isNaacAdminForEvent|| isbpgAdmin||isbpgLeadAdmin)&&(eventCreateDate >= today )&&(eventStatus!='COMPLETED'&& eventStatus!='CLOSED' && eventStatus!='CANCELLED') && (isChapterAdmins ==true) && hideAllButtons == false && iconButtonVisible !='T' && fromLink == false"
      class="alignText top-padding">
      <button type="button"
        class="btn btn-danger col-sm-2 col-md-2 font-family-button button-alignment margin-align ie-position"
        (click)="editEvent()" routerLink="../create-event"
        [disabled]="alertSuccessApproved||alertSuccessRejected||registerSuccessMessage||registerCancelMessage||userWaitingList">REVIEW/EDIT</button>
    </div>

    <div *ngIf="adminId==1||isBpgLeadAdmin==true|| isNaacAdminForEvent">
    
      <div class="alignText top-padding"
        *ngIf="eventStatus=='COMPLETED' && surveyId==null && launchSurvey && fromLink == false">
        <button type="button"
          class="btn btn-danger col-sm-2 col-md-2 font-family-button  button-alignment margin-align ie-position"
          routerLink="../create-survey">LAUNCH SURVEY</button>
      </div>
    
    </div>
    <div class="alignText top-padding"
      *ngIf="(eventStatus=='COMPLETED' && surveyId!=null) && iconButtonVisible !='T' && !(alreadyTakenSurvey) && takeSurvey && (this.userAttendedEvent == true) && fromLink == false">
      <button type="button"
        class="btn btn-danger col-sm-2 col-md-2 font-family-button  button-alignment margin-align ie-position"
        (click)="gotoTakeSurvey()">TAKE SURVEY</button>
    </div>
    <div *ngIf="adminId==1||adminId==2||adminId==3|| isNaacAdminForEvent || isbpgAdmin||isbpgLeadAdmin">
      <div class="alignText top-padding"
        *ngIf="(eventStatus=='SCHEDULED'|| eventStatus=='COMPLETED' || eventStatus=='CANCELLED') && iconButtonVisible !='T'  && (isChapterAdmins ==true)  && fromLink == false">
        <button type="button"
          class="btn btn-danger col-sm-2 col-md-2 font-family-button  button-alignment margin-align ie-position"
          routerLink="../expense-claim" (click)="saveExpenseClaimData()"
          [disabled]="registerSuccessMessage||registerCancelMessage||userWaitingList">BUDGET REQUEST</button>
      </div>
      <div class="alignText top-padding" *ngIf=" iconButtonVisible =='T' && fromLink == false">
        <button type="button"
          class="btn btn-danger col-sm-2 col-md-2 font-family-button button-alignment margin-align padding-style ie-position"
          (click)="clickAttendanceLoad()" data-toggle="modal" data-target="#myModal"
          [disabled]="alertSuccessCompleted">COMPLETE ATTENDANCE</button>
        <app-confirmation-modal [PData]="msg1" (emitPass)="this[method]" id="1"></app-confirmation-modal>
      </div>
    </div>
    <div class="alignText top-padding"
      *ngIf="(adminId==1||adminId==2||adminId==3|| isNaacAdminForEvent || isbpgAdmin || isbpgLeadAdmin)&&(eventStatus=='SCHEDULED'&&validDate == false)&& (isChapterAdmins ==true) && hideAllButtons == false && iconButtonVisible !='T' && fromLink == false">
      <button type="button" id="emailReminderBtnClick"
        class="btn btn-danger col-sm-2 col-md-2 font-family-button  button-alignment margin-align ie-position"
        (click)="sendEmailNotification()"
        [disabled]="registerSuccessMessage||registerCancelMessage||userWaitingList">EMAIL NOTIFICATION</button>
    </div>
    <div class="alignText top-padding ">
      <button type="button"
        class="btn btn-danger col-sm-2 col-md-2 font-family-button button-alignment margin-align ie-position"
        (click)="goBack()"
        [disabled]="alertSuccessApproved||alertSuccessRejected||alertSuccessCompleted||registerSuccessMessage||registerCancelMessage||userWaitingList">BACK</button>
    </div>
  </div>
</div>


<div class="download-back" *ngIf="selectedEventsDetails != null">
  <div class="download-attach-div" *ngIf="selectedEventsDetails.eventDocumentUrl != null"><a
      class="download-attach-a downloadAttachments-btn" id="downloadFiles"
      (click)="downloadAttachments(awsFullUrlsPresignedDoc)">Download Attachments</a></div>
</div>

<!--TABLE -->
<p class="noDataFound text-center" *ngIf="noDataFound && iconButtonVisible =='T'"> No Attendance data found </p>
<div id="tabledemo1" class="table-class" *ngIf="tableShow && iconButtonVisible =='T'">
  <div class="table-container">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
      <thead>
        <tr class="tr-th">
          <th scope="col">Sl.No</th>
          <th scope="col">Workday Id</th>
          <th scope="col" (click)="sortMe('um.user_first_name')" class="name">Attendee First Name <span
              class="sortupdown"><i id="um.user_first_name1" class="fa fa-sort-up"></i><i id="um.user_first_name2"
                class="fa fa-sort-down"></i></span></th>
          <th scope="col">Attendee Last Name</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let data of attendanceData  | paginate: { itemsPerPage: limit, currentPage: currentPage, totalItems: numberOfElements }; let i= index">
          <td>{{ (currentPage - 1) * limit + i + 1 }}</td>
          <td>{{data.workdayId}}</td>
          <td>{{data.userFirstName}}</td>
          <td>{{data.userLastName}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>
</div>

<div class="event-attendence" *ngIf="sendNotification">
  <div class="col-md-12 attendence-section">
    <span class="label-width">Select Site</span>
    <div class="div-style-site">
      <ng-select placeholder="--Select SITE--" [virtualScroll]="true" [multiple]="true" class="custom"
        [items]="siteList" bindLabel="siteName" bindValue="siteId" [(ngModel)]="siteId" (change)="siteChange($event)">
      </ng-select>

    </div>
    <span class="label-width-margin">Select BPG</span>
    <div class="div-style-bpg">
      <ng-select placeholder="--Select BPG--" [multiple]="true" class="custom" [items]="chapterList"
        bindLabel="siteName" bindValue="chapterId" [(ngModel)]="chapterId" (change)="bpgChange($event)"></ng-select>
    </div>
    <button type="button"
      class="btn btn-danger col-sm-2 col-md-2 font-family-button button-alignment margin-align padding-style ie-position button-margin"
      (click)="changeEventStatus('NOTIFICATION')"
      [disabled]="siteId == null || chapterId == null || chapterId == ''">SEND</button>
  </div>
</div>

<ng-template #callAPIDialog>

  <div class="alert alert-danger" *ngIf="noUser">
    No user found !
  </div>
  <div class="alert alert-success" *ngIf="userFound">
    Please select from user dropdown
  </div>
  <div class="alert alert-success" *ngIf="signUpSuccess">
    Signed up for the event successfully!
  </div>

  <div class="alert alert-danger" *ngIf="userExists">
    User already added!
  </div>
  <div class="alert alert-success" *ngIf="userDeleted">
    User deleted successfully!
  </div>
  <div class="alert alert-danger" *ngIf="fileNameExtensionError || fileTemplateError">
   File Format Invalid! Please download the template and fill in the user details.
  </div>
  <div class="alert alert-danger" *ngIf="errorMessageActiveChapterBoard">{{errorMessageChapterBoard}}
  </div>
  <div class="alert alert-success" *ngIf="fileUploaded">
    File Uploaded successfully!
  </div>
  <div class="alert alert-danger" *ngIf="errMsg">
    {{errMsg}} Please reupload the file with valid users.
  </div>

  <div class="fontFamily">
    <h5 style="font-weight: bolder;font-size: 17px;">SIGN UP FOR A GROUP <span
        style="color: #b62027;float:right;font-weight:bold;font-size: 17px">Available Openings - {{availablePostions}}</span></h5>
    <div style="text-align: center;"> <a class="sign-links"  style="color: #b62027"
        *ngIf="screenView=='create' && existingUsers.length>0 && userInput=='true'" (click)="getGroupsignupList()">VIEW EXISTING SIGNED IN
        USERS</a>
        <div *ngIf="screenView=='create'" class="input-heading" >      
          <input type="radio" style="vertical-align: bottom;margin-right:5px"  name="userInput" checked [(ngModel)]="userInput" value='true'>Manual Sign Up
          <input type="radio"      style="margin-left: 4%;vertical-align: bottom;margin-right:5px" name="userInput" [(ngModel)]="userInput" value='false' (click)="removeError()">File Upload
        </div>
      <a class="sign-links" (click)="resetSelectedUser()" *ngIf="screenView=='view'">ADD NEW REGISTRATIONS</a>
    </div>
  </div>
  <div class="container tab-pane">
    <div *ngIf="screenView=='create'">
      <div *ngIf="userInput == 'true'">
    

      <div class="form-group" style="display:flex">
        <div  class="width-change" >
        <label class="sitelabel" for="userName">Select User</label>
        <ng-select placeholder="Select user" [items]="userList" bindLabel="userFirstName"
          [(ngModel)]="userFirstName" (change)="userSelection($event)" (keyup)="findbyEmail($event)" >
          <ng-template ng-option-tmp let-item="item" let-index="index">
            <div>{{item.userFirstName}}</div>
            <div *ngIf="item.division" style="font-size: 11px">{{item.division}}</div>
            <div *ngIf="item.classification" style="font-size: 11px">{{item.classification}}</div>
          </ng-template>
        </ng-select>
      </div>
    </div>


      </div>

      <div *ngIf="userInput == 'false'" style="font-family: 'Montserrat-Light',sans-serif;font-size: 15px;width:680px">
        
          Please download the template by clicking <span (click)="itemDownloadTemplate()" class="manage-file">here</span> and upload the user details. 
        <br>
                <div class="search-tag1" style="padding-top:3%"><input type="text" class="form-control width-class1" maxlength="50"
            placeholder="No file choosen" [(ngModel)]="fileName">
            <input #file type="file" style="width: 10px;" (change)="convertFile($event)" onclick="value = null">
          <button type="button" class="btn btn-danger" #upload (click)="file.click()">UPLOAD</button>
          <div class="icons-style" style="display: inline;">

            
              <i class="fa fa-trash fa-icons"  title="Remove File" *ngIf="(fileName!='' && userInput=='false' && !fileNameExtensionError)" aria-hidden="true" data-toggle="modal" data-target="#myModal" (click)="removeFile()"></i>
              <i class="fa fa-trash fa-icons"  title="Remove File" *ngIf="(fileNameExtensionError)"  (click)="onremoveFileConfirmation()"></i>

            </div>
        </div>
     
   

        </div>


      <div class="table-container" style="max-height: 245px;overflow-y: scroll;">
        <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo"
          *ngIf="selectedUserList.length>0">
          <thead>
            <tr class="tr-th">
              <th scope="col">Name</th>
              <th scope="col">Email ID</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of selectedUserList">
              <td>{{data.userFirstName}}</td>
              <td>{{data.emailId}}</td>
              <td>
                <a class="deleteButton delete-button-style zoom-in-style" title="delete"
                  (click)="removeUser(data.userId)"><img src="assets/images/delete.png" class="image" alt="Angular Logo"></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div class="table-container" style="max-height: 245px;overflow-y: scroll;"  *ngIf="alreadyRegisteredList.length>0">
        <span class="input-heading font-weight-bold text-center py-4" style="color:#b62027 !important">Following users have already been signed up for this event.</span>
        <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo"
         >
         
          <thead>
            <tr class="tr-th">
              <th scope="col">Name</th>
              <th scope="col">Email ID</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of alreadyRegisteredList">
              <td>{{data.userFirstName}}</td>
              <td>{{data.emailId}}</td>
            </tr>
          </tbody>
        </table>
      </div>
        <div class="clear"></div>

        <div class="btn-div1 alignment">
        
          <button (click)="signUpForGroup()" id="signIn" data-toggle="modal" data-target="#myModal"
            class="btn btn-danger margin-save" [disabled]="selectedUserList.length == 0 || fileNameExtensionError || fileTemplateError">SIGN UP</button>
          
          <button type="button" class="btn btn-danger margin-save" *ngIf="userInput=='true'"(click)="resetSelectedUser()"
            [disabled]="selectedUserList.length == 0 && alreadyRegisteredList.length == 0">RESET</button>        

          <button type="button" class="btn btn-danger margin-save" data-toggle="modal" data-target="#myModal"
            (click)="closeDialog('close')">CLOSE</button>
       
      </div>
    </div>
    <div class="table-container" *ngIf="existingUsers.length>0 && screenView=='view'">
      <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped" id="tabledemo">
        <thead>
          <tr class="tr-th">
            <th scope="col">Name</th>
            <th scope="col">Email ID</th>
            <th scope="col">Status</th>
            <th scope="col">Actions</th>

          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let data of existingUsers | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements },let i = index">
            <td>{{data.userFirstName}} {{data.userLastName}}</td>
            <td>{{data.emailId}}</td>
            <td>{{data.status}}</td>


            <td>

              <a class="deleteButton delete-button-style zoom-in-style" title="delete" data-toggle="modal"
                data-target="#myModal" (click)="removeUserFromSignUp(data.userId)"><img src="assets/images/delete.png"
                  class="image" alt="Angular Logo"></a>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="clear"></div>

      <div class="btn-div1 alignment" style="margin-left: 35%;">

        <button type="button" class="btn btn-danger margin-save" data-toggle="modal" data-target="#myModal"
          (click)="closeDialog('close')">CLOSE</button>
      </div>
    </div>

  </div>
</ng-template>
